var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoCartPlus = function SvgIcoCartPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.65 23.63"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.22 13.25.41 2A2.08 2.08 0 0 0 7.68 17h11.69a2.09 2.09 0 0 0 1.92-1.26l.77-2.4Z",
    style: {
      opacity: 0.3
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.39 8.24A2.43 2.43 0 0 0 22.8 7l-2.16-.5a1 1 0 1 0-.45 1.95l2.15.5a.41.41 0 0 1 .27.21.46.46 0 0 1 0 .4l-2 5.75a1.11 1.11 0 0 1-1 .66H7.87a1.09 1.09 0 0 1-1.07-.86L5.12 6v-.06c0-.18.29-.34.47-.42a2.63 2.63 0 0 1 1.63-.12 1 1 0 1 0 .48-1.95 4.57 4.57 0 0 0-2.91.24h-.08l-.11-.55A4 4 0 0 0 1.09 0 1 1 0 0 0 0 .91 1 1 0 0 0 .91 2a1.91 1.91 0 0 1 1.72 1.52l2.21 12a3.09 3.09 0 0 0 3 2.48h11.72a3.12 3.12 0 0 0 2.87-2l2-5.75a2.4 2.4 0 0 0-.04-2.01ZM17.8 18.68a2.48 2.48 0 1 0 2.47 2.47 2.48 2.48 0 0 0-2.47-2.47Zm0 2.95a.48.48 0 0 1-.47-.48.47.47 0 0 1 .94 0 .48.48 0 0 1-.47.48ZM9.71 18.68a2.48 2.48 0 1 0 2.47 2.47 2.48 2.48 0 0 0-2.47-2.47Zm0 2.95a.48.48 0 0 1-.47-.48.47.47 0 1 1 .94 0 .48.48 0 0 1-.47.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.14 6.74h1.5v1.5a1 1 0 1 0 2 0v-1.5h1.5a1 1 0 0 0 0-2h-1.5v-1.5a1 1 0 0 0-2 0v1.5h-1.5a1 1 0 0 0 0 2Z"
  })))));
};
export default SvgIcoCartPlus;